import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useParams, MESSAGES } from './../../common/helper/common-imports.component.js'; 
import { FormField, SelectField } from './../../common/helper/formFields';
import {initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import {AgentsService,ConfigService} from "../../../services/index.js";


const AddAgent = () => { 
    const [loading, setLoading] = useState(false);
  const [formData,setFormData] = useState({
    fullName : '',
    email : '',
    gender : '',
    limit_group_id : '',
    nationalID : '',
    datofBirth : '',
    phoneNumber : '',
    comm_grp_id : '',
  });
  const [errors, setErrors] = useState({ ...initialErrors });
  const gender = [{ label : 'Male', value : 'M'},{label : 'Female',value : 'F'}]
  const [passwordChange, setPasswordChange] = useState({});
  const navigate = useNavigate();
  const [limitGroup, setLimit] = useState([]);
  const [commGroup, setCommGroup] = useState([]);

  const { id } = useParams();
  const fetchData = async () => {
    try {
      setLoading(true);
       const [commResponse, limitResponse] = await Promise.all([
        ConfigService.getCommGroups('AGENT'),
        ConfigService.getLimitGroups(),
      ]);

      const limit =  limitResponse.data.data.map(record => ({ value: record.key, label: record.value, is_default: record.is_default }));
      const comm =   commResponse.data.data.map(record => ({ value: record.key, label: record.value, is_default: record.is_default }));
     
      setCommGroup(comm);
      setLimit(limit)
      setLoading(false);
    } catch (error) {
      setLoading(false);

    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  }
  const validateField = (fieldName, value) => {
    let errorMessage = fieldValidation(fieldName, value);
    if (fieldName === 'confirmationPassword') {
    if (value && value !== passwordChange.new_password) {
      errorMessage = 'Password and confirm password not matched';
    } 
  }
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
  };


  const updateBasicInfo = (e) => {
    e.preventDefault();
    
    Object.keys(formData).forEach((fieldName) => validateField(fieldName, formData[fieldName]));
    console.log(formData)
    const hasErrors = Object.entries(formData).some(([key, value]) => {
        if (key === "nationalID") return false;
        return value === '';
    });
    if(!hasErrors){

        setLoading(true);
        const inputDate = formData.datofBirth; 
        const parts = inputDate.split('-');
        const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
        const dataToupdate = {

            "full_name": formData.fullName,
            //"user_id": id,
            "email_address": formData.email,
            "mobile_number": formData.phoneNumber,
            "date_of_birth": formattedDateOfBirth,
            "gender_id": formData.gender,
            //"national_id": formData.nationalID,
            "comm_grp_id":formData.comm_grp_id,
            "limit_group_id": formData.limit_group_id,
            "auto_generate_password": true
          }
          updateAgentProfile(dataToupdate)
        }
  }

  

  const updateAgentProfile = (data) => {
    AgentsService.addAgent(data)
          .then(response => {
            setLoading(false);
            navigate('/agents')
            toast.success(MESSAGES.AGENT_CREATED)
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
  }
  const back = () => {
    navigate(-1); 
  }

    useEffect(() => {
        fetchData();
    // getAgent() //updateBasic(userData.user.data);
      //getStates();
      document.body.style.backgroundImage = '';

        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);

    return (
        <>
            <LoaderOverlay loading={loading} />
            <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
              <h4 className="updatename" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Update Agent</h4>
              <div className="container" style={{backgroundColor: 'white'}}>
                <nav>
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active tbbtn" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Basic Information</button>
                   
                  </div>
                </nav>
                <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
                  <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                    <form onSubmit={updateBasicInfo}>
                    <div className="panel panel-default">
                      <div className="panel-body" style={{padding: '0px'}}>
                        <div className="col-md-12" style={{padding: 0}}>
                          <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                       
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {true}
                                   id="f_name"
                                   name="fullName"
                                   label="FULL NAME"
                                   placeholder = "Enter Full Name"
                                   value={formData.fullName}
                                   onChange={handleChange}
                                   error={errors.fullName}
                                   maxlength = {20}
                                   
                                   
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {true}
                                   id="email"
                                   name="email"
                                   label="EMAIL"
                                   placeholder = "Enter email"
                                   value={formData.email}
                                   onChange={handleChange}
                                   error={errors.email}
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <SelectField 
                                        id="gender"
                                        isRequierd = {true}
                                        name="gender"
                                        label="GENDER"
                                        selectedField = "Select Gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        error={errors.gender}
                                        options={gender}
                                        />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                          <SelectField 
                            id="comm_grp_id"
                            isRequierd = {true}
                            name="limit_group_id"
                            label="Limit GROUP"
                            selectedField = "Select Limit Group"
                            value={formData.limit_group_id}
                            onChange={handleChange}
                            error={errors.limit_group_id}
                            options={limitGroup}
                            />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>
                          </div>
                          <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                         
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="date"
                                   isRequierd = {true}
                                   id="datofBirth"
                                   name="datofBirth"
                                   label="DATE OF BIRTH"
                                   placeholder = "Enter DOB"
                                   value={formData.datofBirth}
                                   onChange={handleChange}
                                   error={errors.datofBirth}
                                />
                            </div>
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                            <FormField
                                   type="text"
                                   isRequierd = {true}
                                   id="phoneNumber"
                                   name="phoneNumber"
                                   label="PHONE NUMBER"
                                   placeholder = "Enter Phone Number"
                                   value={formData.phoneNumber}
                                   onChange={handleChange}
                                   error={errors.phoneNumber}
                                   maxlength = {10}
                                />
                            </div>
                     
                            <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                          <SelectField 
                            id="comm_grp_id"
                            isRequierd = {true}
                            name="comm_grp_id"
                            label="COMMISSIOM GROUP"
                            selectedField = "Select Commission Group"
                            value={formData.comm_grp_id}
                            onChange={handleChange}
                            error={errors.comm_grp_id}
                            options={commGroup}
                            />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>
                          </div>
                        </div>
                        <br />
                        <div align="left">
                        <button type="button" name="btn_login_details" id="btn_login_details" className="btn backbt" style={{marginTop:'6px'}} onClick={back}>Back</button>
                  <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginLeft:'10px'}}>Submit</button>
                        </div>
                        <br />
                      </div>
                    </div>
                    </form>
                  </div>
                  

                </div>
              </div>
            </div>
            </>
          );
        
        }

          function mapStateToProps(state) {
            const userData = state.authReducer.user;
            return { userData };
          }
        export default withAuth(connect(mapStateToProps)(AddAgent));